import ActionTypes from "../../../constants/ActionTypes";
import { IUserMessageLabel } from "./types";

const initialState: IUserMessageLabel = {
  label: "",
  entity: "",
};

export default (state = initialState, action: any): IUserMessageLabel => {
  if (action.type.includes(ActionTypes.USER_MESSAGE.SET)) {
    return {
      ...state,
      label: action.payload.label,
      entity: action.payload.entity,
    };
  }

  return state;
};
